<template>
  <div class="mt-5">
    <img src="../../assets/images2.0/forum/no_result_forum.svg" alt="forum no result icon"/>
    <h4 class="mt-3">No Results Found</h4>
    <div class="mt-3">Try with different text</div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
